// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".bb35f576b167ad2e70a8e26fe3c0a34f.js";
};